import { BorderGridContainer, GridBox, TypeWrapper } from '@ahmdigital/ui';
import { PRODUCT_TYPE } from '@ahmdigital/constants';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import { buildNavigationUrl } from '../../../src/client/pages/build-your-cover/utils/navigation';
import { FLOW_SLUGS, STEP_SLUG, VALID_JOURNEY_TYPES } from '../../../src/client/pages/build-your-cover/constants';
import { ProductTypeType } from '../../../src/client/types/product';
import buildFaqPageSchema from '../../../src/client/components/structured-data/utils/build-faq-page-schema';
import byocFaqs from './faqs';
import selectBuildYourCover from '../../../src/client/selectors/select-build-your-cover';
import selectCustomer from '../../../src/client/selectors/select-customer';
import StructuredData from '../../../src/client/components/structured-data';
import Welcome from '../../../src/client/pages/build-your-cover/components/welcome';
import type { JourneyProductType, StepSlug } from '../../../src/client/pages/build-your-cover/types';

const isStepSlug = (slug: string | null): slug is StepSlug => Object.values(STEP_SLUG).includes(slug as StepSlug);

const isJourneyProductType = (type: ProductTypeType | undefined): type is JourneyProductType =>
  VALID_JOURNEY_TYPES.includes(type as JourneyProductType);

const useIsRedirect = () => {
  const router = useRouter();
  const { hasRefinedPrice, productType } = useSelector(selectCustomer);
  const { activeStep } = useSelector(selectBuildYourCover);
  const [isRedirecting, setIsRedirecting] = useState(false);

  const journeyType = isJourneyProductType(productType) ? productType : PRODUCT_TYPE.PACKAGE;

  const defaultStep = journeyType === PRODUCT_TYPE.EXTRAS ? STEP_SLUG.EXTRAS : STEP_SLUG.HOSPITAL;
  const targetStep = isStepSlug(activeStep) && FLOW_SLUGS[journeyType].includes(activeStep) ? activeStep : defaultStep;

  useEffect(() => {
    if (!hasRefinedPrice || isRedirecting) return;
    setIsRedirecting(true);
    router.replace(buildNavigationUrl(targetStep, journeyType));
  }, [hasRefinedPrice]); // eslint-disable-line react-hooks/exhaustive-deps

  return hasRefinedPrice || isRedirecting;
};

const ChooseYourCoverPage = () => {
  const isRedirecting = useIsRedirect();

  if (isRedirecting) {
    return null;
  }

  return (
    <>
      <StructuredData data={buildFaqPageSchema(byocFaqs)} />
      <BorderGridContainer hideBorderTop>
        <GridBox padding="0 0 1rem 0">
          <TypeWrapper variant="marginBottomSpacer6">
            <Welcome />
          </TypeWrapper>
        </GridBox>
      </BorderGridContainer>
    </>
  );
};

export default ChooseYourCoverPage;
